import React, { forwardRef } from "react";
import { Stack, Typography, Button, IconButton, Tooltip } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";

const FileUpload = forwardRef(({ label, onClick, onChange, file, onRemove, type }, ref) => {  
  const { fileName, url } = file;

  const openFile = (url, event) => {
    if (url) window.open(url, "_blank");
    event.stopPropagation();
  };

  return (
    <Stack sx={{ width: "100%", position: "relative" }} onClick={url ? (e) => openFile(url, e) : onClick}>
      <Stack
        flexDirection="row"
        alignItems="center"
        sx={{
          position: "relative",
          border: "1px solid #c4c4c4",
          borderRadius: "4px",
          padding: "0 8px",
          cursor: "pointer",
          backgroundColor: "white",
          height: "56px",
          transition: "border-color 0.2s ease-in-out",
          "&:hover": { borderColor: "#1976d2" },
          "&:focus-within": { borderColor: "#1976d2" },
        }}
      >
        {fileName && (
          <Typography
            sx={{
              position: "absolute",
              top: -10,
              left: 12,
              backgroundColor: "white",
              padding: "0 4px",
              fontSize: "12px",
              color: "rgba(0, 0, 0, 0.6)",
            }}
          >
            {label} 
          </Typography>
        )}
        <AttachFileIcon sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: 20, mr: 1 }} />
        <Typography sx={{ flex: 1, color: fileName ? "#000" : "rgba(0, 0, 0, 0.6)" }}>
            {fileName || `${label} (1.5MB)`}
        </Typography>
        {!!onRemove && (
          fileName ? (
            <Tooltip title="Remove file">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove();
                }}
                size="small"
              >
                <ClearIcon sx={{ fontSize: 20, color: "rgba(0, 0, 0, 0.6)" }} />
              </IconButton>
            </Tooltip>
          ) : (
            <Button
              variant="text"
              sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "14px", fontWeight: 500 }}
            >
              Choose File
            </Button>
          )
        )}
        <input
          ref={ref}
          type="file"
          accept={type || "application/pdf"}
          onChange={onChange}
          style={{ display: "none" }}
        />
      </Stack>
    </Stack>
  );
});

export default FileUpload;
